export default "__VITE_ASSET__DnzopoXW__"